import Vue from 'vue';

Vue.component('msp-api-error', {
  props: ['response'],

  render(createElement) {
    if (!this.response) {
      return null;
    }

    const { message, error, data } = this.response;

    if (error !== 'ValidationException') {
      return createElement('div', message);
    }

    const errors = Object.keys(data)
      .reduce((values, key) => values.concat(data[key]), [])
      .filter(e => !!e);

    return createElement('div', errors[0]);
  },
});
